module.exports = __webpack_public_path__ + "img/no_camera.d93a3c42.png";